<table
aria-describedby="associatedDealers"
class="tablest1 border-bottom mt-2"
>
<ng-container>
  <thead>
    <tr>
      <th scope="col" translate>lblCode</th>
      <th scope="col" translate>lblName</th>
      <th scope="col" translate>lblDescription</th>
    </tr>
  </thead>
</ng-container>

<tbody>
  <ng-container
    *ngIf="
      giftCards?.length > 0 ||
        giftCards?.length > 0;
      else load_else
    "
  >
    <ng-container *ngIf="giftCards?.length > 0">
      <tr
        *ngFor="
          let giftcard of giftCards;
          let i = index
        "
      >
        <td>{{ giftcard.code }}</td>
        <td>{{ giftcard.name }}</td>
        <td>{{ giftcard.description }}</td>
      </tr>
    </ng-container>
  </ng-container>
  <ng-template #load_else>
    <tr>
      <td colspan="10" class="no-record" translate>lblNoRecordsFound</td>
    </tr>
  </ng-template>
</tbody>
</table>